//
//
//
//
//
//
//
//


export default {
	name: 'BtnBack',

	props: {
		path: {
			type: String,
			default: ''
		}
	},

	computed: {
		defaultLink: function defaultLink() {
			var lang = '';
			switch (this.$route.params.lang) {
				case 'en':
					lang = '/eng';
					break;
			}
			return lang + '/' + this.$route.params.page;
		},
		link: function link() {
			return this.path || this.defaultLink;
		}
	},

	methods: {
		clickHandler: function clickHandler() {
			if (this.path) {
				this.$router.push(this.path);
			} else if (window.history.length > 1) {
				this.$router.go(-1);
			} else {
				this.$router.push(this.defaultLink);
			}

			/*if (this.path) this.$router.push(this.path)
   else this.$router.go(-1)*/
			//this.$router.push(this.link)
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BtnBack.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BtnBack.vue
// module chunks = 1 2